import { HeaderProps } from "./dto";

export function Header(props: HeaderProps) {
    return (
        <div
            className="bg-brandPrimary-800 flex items-center gap-6 px-7 min-h-[60px] rounded-tl-[20px] border-b border-white/10"
        >
            {props.icon && (
                <div className="opacity-70 flex items-center justify-center">
                    {props.icon}
                </div>
            )}

            <div className="flex items-center gap-5">
                <span
                    className="text-brandPrimary-50 font-semibold tracking-wide text-[15px]"
                >
                    {props.label}
                </span>

                {props.customerName && (
                    <>
                        <div className="w-px h-4 bg-white/20" />
                        <span className="text-white/60 text-sm font-normal">
                            Cliente: <span className="text-white/90 font-medium">{props.customerName}</span>
                        </span>
                    </>
                )}

                {props.customerCode && (
                    <>
                        <div className="w-px h-4 bg-white/20" />
                        <span className="text-white/60 text-sm font-normal">
                            Cod. <span className="text-white/90 font-medium">{props.customerCode}</span>
                        </span>
                    </>
                )}
            </div>

            <div className="flex items-center flex-1">
                {props.children}
            </div>
        </div>
    );
}